import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { MTFieldsStyled } from './styled'
import { InboxUtils } from '../../../redux/inbox'
import InfoChip from '../info-chip'

// Textos de cada campo, con la misma lógica de siempre (arrays, objetos y mapeo por remote_name)
const getFieldLabels = (values, mapValues) => _.flatMap(_.map(values, (value, label) => {
  if (_.isArray(value)) {
    return _.map(value, (multiValue, multiLabel) => ({
      key: `${label}-${multiLabel}`,
      text: label === 'estado' ? InboxUtils.getStatusText(multiValue) : multiValue
    }))
  } else if (typeof value === 'object') {
    let item = { value: null, label: '' }
    _.map(Object.keys(value), (newLabel) => {
      item = {
        value: label, label: `${item.label} ${item.value ? ' - ' : ''}${value[newLabel] ? value[newLabel] : '/'}`
      }
    })
    return [{ key: item.value, text: item.label }]
  } else if (!_.isEmpty(mapValues)) {
    return [{ key: label, text: _.get(_.find(mapValues, v => v.remote_name === value), 'name', value) }]
  }
  return [{ key: label, text: label === 'estado' ? InboxUtils.getStatusText(value) : value }]
}))

// Cada campo como InfoChip del Storybook de Velora
const MTFields = ({ values, mapValues, useCapitalize = true }) => (
  <MTFieldsStyled useCapitalize={useCapitalize ? 'capitalize' : 'none'}>
    {getFieldLabels(values, mapValues).map(({ key, text }) => (
      <InfoChip key={key} label={text} title={_.isString(text) ? text : undefined} />
    ))}
  </MTFieldsStyled>
)

MTFields.propTypes = {
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  mapValues: PropTypes.array
}

export default MTFields
